<template>
  <div>
    <section class="text-section">
      <div class="container">
        <h1>ПОЛИТИКА ОБРАБОТКИ ФАЙЛОВ COOKIE</h1>
        <p>
          При посещении сайта bytorg.by ООО «Байторг Бай» использует файлы
          cookie для корректной и безопасной работы сайта, а также, с согласия
          пользователя, для анализа использования сервиса и его улучшения.
        </p>
        <p>
          Пользователь может самостоятельно выбрать, какие категории cookie
          разрешено использовать.
        </p>

        <h2>Что такое файлы cookie</h2>
        <p>
          Cookie — это небольшие фрагменты данных, которые сайт сохраняет в
          браузере пользователя.
        </p>
        <p>
          Они помогают сайту обеспечивать работу отдельных функций, запоминать
          настройки пользователя и, при наличии согласия, собирать
          статистическую информацию об использовании сайта.
        </p>

        <h2>Какие cookie используются</h2>
        <p>На сайте Bytorg используются две категории cookie:</p>
        <ul>
          <li>
            <strong>Необходимые cookie</strong> — обеспечивают работу основных
            функций сайта и всегда активны.
          </li>
          <li>
            <strong>Аналитические cookie</strong> — используются для анализа
            посещаемости и взаимодействия пользователей с сайтом. Они
            применяются только с согласия пользователя.
          </li>
        </ul>

        <h2>Для чего используются cookie</h2>
        <p>Файлы cookie могут использоваться для:</p>
        <ul>
          <li>корректной и безопасной работы сайта;</li>
          <li>авторизации и поддержания пользовательской сессии;</li>
          <li>сохранения настроек пользователя;</li>
          <li>сохранения выбранных параметров использования cookie;</li>
          <li>анализа посещаемости сайта;</li>
          <li>
            понимания того, какие разделы и функции сервиса используются чаще;
          </li>
          <li>выявления ошибок и улучшения работы Bytorg.</li>
        </ul>

        <h2>Как управлять файлами cookie</h2>
        <p>
          При первом посещении сайта пользователь может выбрать один из
          вариантов:
        </p>
        <ul>
          <li>
            <strong>«Принять все»</strong> — разрешить использование необходимых
            и аналитических cookie;
          </li>
          <li>
            <strong>«Только необходимые»</strong> — использовать только cookie,
            необходимые для работы сайта;
          </li>
          <li>
            <strong>«Настроить»</strong> — самостоятельно выбрать разрешённые
            категории cookie.
          </li>
        </ul>
        <p>
          Настройки cookie можно изменить в любое время через пункт «Настройки
          cookie» на сайте.
        </p>
        <p>
          Пользователь также может удалить или ограничить использование cookie
          средствами браузера. При блокировке необходимых cookie отдельные
          функции сайта могут работать некорректно.
        </p>
      </div>
    </section>
    <footer class="footer">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-sm-4 col-lg-5">
            <img
              src="../assets/img/logo.png"
              alt=""
              class="footer-logo"
              width="113"
              height="54"
            />
          </div>
          <div class="col-sm-8 col-lg-7">
            <div class="row">
              <div class="offset-md-6 col-md-6">
                <router-link :to="termsOfUsePath" exact class="footer-link">
                  <span>Правила пользования</span>
                  <ico name="icoOpenInNew" color="#79919C"></ico>
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="row align-items-center">
          <div class="col-xl-4 order-xl-2">
            <div class="footer-contacts">
              <div class="footer-contacts-item">
                <p class="footer-contacts-item-title">Телефон</p>
                <a class="footer-contacts-item-link" href="tel:+375447228833"
                  >+375447228833</a
                >
              </div>
              <div class="footer-contacts-item">
                <p class="footer-contacts-item-title">Вопросы и предложения</p>
                <a
                  class="footer-contacts-item-link"
                  href="mailto:office@bytorg.by"
                  >office@bytorg.by</a
                >
              </div>
            </div>
          </div>
          <div class="col-xl-8 order-xl-1">
            <p class="footer-copyright">© ООО “Байторг Бай”, 2024</p>
            <p class="footer-copyright">
              Копирование материалов запрещено. При согласованном использовании
              материалов сайта необходима ссылка на ресурс.
            </p>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { homePath } from "@/router/home";
import { termsOfUsePath } from "@/router/termsOfUse";
import Configuration from "@/configuration";
import { cookiePath } from "@/router/cookie";

export default {
  name: "Cookie",
  data() {
    return {};
  },
  computed: {
    baseUrl() {
      return Configuration.value("apiEndpoint");
    },
    cookiePath() {
      return cookiePath.substring(1);
    },
    termsOfUsePath() {
      return termsOfUsePath;
    },
    homePath() {
      return homePath;
    },
  },
};
</script>

<style lang="less" scoped>
@import "../assets/less/variables.less";
@import "../assets/less/bootstrapGrid.less";
@import "../assets/less/commonStyles.less";
@import "../assets/less/homeStyles.less";

.header {
  padding-top: 24px;
  padding-bottom: 24px;

  .container {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
}

@media (max-width: 575px) {
  .footer {
    &-logo {
      margin: 0 auto 32px;
    }
  }
}
</style>
